import { classNames } from '@utils/classNames.ts';

type ExternalLinkProps = {
  href: string | undefined;
  text: string;
  className?: string;
};

export function ExternalLink({ href, text, className }: ExternalLinkProps) {
  return (
    <a
      href={href}
      className={classNames(
        'flex flex-row justify-start items-center break-all',
        className,
      )}
      target="_blank"
    >
      {text}
    </a>
  );
}
